/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CustomersInputs */

const vi_nav_customers = /** @type {(inputs: Nav_CustomersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách hàng`)
};

/**

* @param {Nav_CustomersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_customers = /** @type {((inputs?: Nav_CustomersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CustomersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_customers(inputs)
});